import {ActionCreatorDefinition, createAction} from "redux-ts";
import {ModalType} from "enum/ModalType";
import {ComplianceFlowType} from "enum/ComplianceFlowType";

export const SetComplianceFlowType: string =  "SetComplianceFlow";
export const SetModalType: string =  "SetModal";
export const CloseMeType: string =  "CloseMe";
export const SetBarBottomMetricsType: string =  "SetBarBottomMetrics";

export interface SetComplianceFlowPayload {

    complianceFlowType: ComplianceFlowType;
}

export interface SetModalPayload {

    modalType: ModalType;
    visible: boolean;
}


export interface SetBarBottomMetricsPayload {

    height?: number;
}

export const SetComplianceFlow: ActionCreatorDefinition<SetComplianceFlowPayload, any> = createAction<SetComplianceFlowPayload>(SetComplianceFlowType);
export const SetModal: ActionCreatorDefinition<SetModalPayload, any> = createAction<SetModalPayload>(SetModalType);
export const CloseMe: ActionCreatorDefinition<any, any> = createAction<any>(CloseMeType);
export const SetBarBottomMetrics: ActionCreatorDefinition<SetBarBottomMetricsPayload, any> = createAction<SetBarBottomMetricsPayload>(SetBarBottomMetricsType);
